import {Component, EventEmitter, OnInit} from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { UserService } from '../services/users/user.service';

import { locale as english } from '../i18n/en';
import { locale as spanish } from '../i18n/es';
import { FuseTranslationLoaderService } from '../../core/services/translation-loader.service';
import { environment } from '../../../environments/environment';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { Subscription } from 'rxjs';
import { FuseChatComponent } from '../content/pages/chat/chat.component';
import {ShiftService} from '../services/shifts/shift.service';
import {Observable} from 'rxjs/Observable';
import {Shift} from '../models/shifts/shift';
import { SchoolYear } from '../models/school-years/school-year';
import { SchoolYearService } from '../services/schoool-year/school-year.service';
import { StudentService } from '../services/students/student.service';
import { IUser } from '../models/users/iuser';
import { FuseChangePasswordComponent } from '../content/pages/management/users/components/change-password/change-password.component';
import { SweetAlertService } from '../services/sweet-alert/sweet-alert.service';

@Component({
    selector   : 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class FuseToolbarComponent implements OnInit
{
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    public baseUri;
    confirmDialogRef: any;
    private afterClosed$: Subscription;
    private onNewMessageService: EventEmitter<any>;
    public n : number = 0;
    public notifications = [];
    public shifts: Shift[] = [];
    public schoolYears: SchoolYear[] = [];
    public schoolYear: SchoolYear;
    public logo;

    constructor(
        private router: Router,
        private fuseConfig: FuseConfigService,
        private translationLoader: FuseTranslationLoaderService,
        public authenticationService: AuthenticationService,
        public studentService: StudentService,
        private translate: TranslateService,
        private userService: UserService,
        public dialog: MatDialog,
        public shiftService: ShiftService,
        private schoolYearService: SchoolYearService,
        private sweetAlertService: SweetAlertService,
    )
    {
        this.baseUri = environment.baseUri;
        // this.translationLoader.loadTranslations(english, spanish);

        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                'id'   : 'en',
                'title': 'LANGUAGES.ENGLISH',
                'flag' : 'us'
            },
            {
                'id'   : 'es',
                'title': 'LANGUAGES.SPANISH',
                'flag' : 'es'
            }
        ];

        let userLanguage = this.authenticationService.getLanguage();
        console.log('FuseToolbarComponent > userLanguage', userLanguage);
        let selectedLanguage = this.languages.find(l => l.id === userLanguage);
        console.log('FuseToolbarComponent > selectedLanguage', selectedLanguage);
        this.selectedLanguage = !!selectedLanguage ? selectedLanguage : this.languages[0];
        console.log('FuseToolbarComponent > this.selectedLanguage', this.selectedLanguage);

        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                    this.showLoadingBar = true;
                }
                if ( event instanceof NavigationEnd )
                {
                    this.showLoadingBar = false;
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

        // escuchando notifications
        // this.onNewMessageService = this.messagingService.onNewMessage.subscribe(m => {
        //     console.log('notification', m.title);
        //     this.n++;
        //     this.notifications.push(m.notification.title);
        // });
    }

    ngOnInit() {
        // Use a language
        this.logo = environment.logo;
        let userLanguage = this.authenticationService.getLanguage();
        console.log('FuseToolbarComponent > ngOnInit > userLanguage', userLanguage);
        this.translate.use(!!userLanguage && userLanguage.match(/en|es/) ? userLanguage : 'en');
        if (this.authenticationService.getAuthData() !== null) {
            this.schoolYear = this.authenticationService.getAuthData().SchoolYear;
            Observable.combineLatest(
                this.schoolYearService.getAll()
            ).subscribe(([schoolYears]) => {
                this.schoolYears = schoolYears;
            });
        } else {
            this.schoolYear = new SchoolYear();
        }
    }

    search(value)
    {
        // Do your search here...
        console.log(value);
    }

    public logout() {
        this.authenticationService.logout();
        this.studentService.students = [];
        this.studentService.historyStudent = null;
        this.studentService.studentObject = {};
        this.studentService.historyStudentObject = null;
        this.router.navigate(['pages/auth/login-2']);
    }

    changePassword() {
        console.log(this.authenticationService.getAuthData());
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                user: JSON.parse(JSON.stringify(this.authenticationService.getAuthData()))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseChangePasswordComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseUsersComponent > changePassword > result', result);
            if (result) {
                this.sweetAlertService.info("Aviso", "Por favor, inicie sesión nuevamente", this.logout());
            }
        });
    }

    openFusionChat() {
        const config: MatDialogConfig = {
            height: '90%',
            width: '90%',
            disableClose: false,
            panelClass: 'fw-task-manager-dialog',
            // data: {
            //     case: this.case
            // }
        };
        this.confirmDialogRef = this.dialog.open(FuseChatComponent, config);
        //this.countMessage = 0;

        this.afterClosed$ = this.confirmDialogRef.afterClosed().subscribe(result => {
           // this.countMessage = 0;
            //this.detectChanges();
        });
    }

    public changeLanguage(language: any) {
        console.log('FuseToolbarComponent > changeLanguage');
        if (this.selectedLanguage.id !== language.id) {
            console.log('FuseToolbarComponent > changeLanguage > valid');
            this.selectedLanguage = language;
            let userId = this.authenticationService.getUserId();
            this.userService.editLanguageByUserId(userId, language.id).subscribe(response => {
                console.log('FuseToolbarComponent > changeLanguage > response', response);
                if (response.ResultCode == 1) {
                    let authData = this.authenticationService.getAuthData();
                    authData.Language = language.id;
                    this.authenticationService.setAuthData(authData);
                    this.translate.use(language.id);
                } else {
                    // TODO Implementar mensaje de error
                }
            }, error => {
                // TODO Implementar mensaje de error
            });
        }
    }

    changeSchoolYear(schoolYear: SchoolYear) {
        const authData = this.authenticationService.getAuthData();
        authData.SchoolYear = schoolYear;
        this.authenticationService.setAuthData(authData);
        window.location.reload();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/toolbar/toolbar.component.ts